// Max CSV rows per rating tool upload: one upload is one job on a concurrency-1 queue, so an uncapped file blocks every other admin's export.
export const RATING_TOOL_MAX_ROWS = 1000;
